import { useSchedules } from '@accounts';

export function useRecheckSchedules(accountId: number) {
  const bookable = useSchedules(true, { enabled: false });
  const setAside = useSchedules(false, { enabled: false });

  return {
    isFetching: bookable.isFetching || setAside.isFetching,
    recheck: async () => {
      const [yes, no] = await Promise.all([bookable.refetch(), setAside.refetch()]);

      return [...(yes.data ?? []), ...(no.data ?? [])].filter(
        (schedule) => schedule.account_id === accountId
      );
    },
  };
}
